import get from 'lodash/get';
import moment from 'moment';
import { bool, func, objectOf, shape, string } from 'prop-types';
import React, { Component } from 'react';
import { isInclusivelyBeforeDay } from 'react-dates';
import {
  Alert,
  Button,
  ButtonGroup,
  Col,
  Label,
  ListGroup,
  ListGroupItem,
  Row,
} from 'reactstrap';

import { combineLinesByBusinesses } from '../../campaign-editor/transform-for-rendering';
import { isDraft } from '../../campaign-editor/utils';
import DatePicker from '../../generic/DatePicker';
import { campaignLineShape } from '../../prop-types';
import getEventTargetValue from '../../utils/get-event-target-value';
import CampaignLineSummary from './CampaignLineSummary';

export const nameKey = 'selectedLines';

class ChangeRuntimeForm extends Component {
  applySelectionToAll(runtimeConfigurableLines, value) {
    runtimeConfigurableLines.forEach(({ id }) => {
      const syntheticEvent = { target: { name: `${nameKey}.${id}`, value } };
      this.props.onChange(syntheticEvent);
    });
  }

  toggleProductLineSelection(productId, productLines, event) {
    const select = getEventTargetValue(event.target);
    const productValues = productLines.filter(
      item => item.product.id === productId,
    );
    this.applySelectionToAll(productValues, select);
  }

  toggleAllLineSelection(productLines, select) {
    this.applySelectionToAll(productLines, select);
  }

  renderCampaignLines(product) {
    const { value, campaignLinesById, onChange } = this.props;

    return product.countries.map(country =>
      country.lines.map(lineId => {
        const isSelected = !!value.selectedLines[lineId];
        const line = campaignLinesById[lineId];
        return (
          <ListGroupItem color={isSelected ? 'primary' : ''} key={lineId}>
            <CampaignLineSummary
              nameKey={nameKey}
              line={{
                ...line,
                endDate: isSelected ? value.proposedEndDate : line.endDate,
              }}
              isSelected={isSelected}
              onChange={onChange}
            />
          </ListGroupItem>
        );
      }),
    );
  }

  render() {
    const { onChange, campaignLinesById, value } = this.props;

    const configurableRuntimeLines = Object.values(campaignLinesById).filter(
      line => get(line, 'product.overwriteTimeRange', false) && !isDraft(line),
    );

    if (configurableRuntimeLines.length === 0) {
      return (
        <Alert color="warning">
          There are no lines in this campaign for which the runtime can be
          changed
        </Alert>
      );
    }

    const linesCombinedByBusinesses = combineLinesByBusinesses(
      configurableRuntimeLines,
    );

    const previousDay = moment().add(-1, 'days');

    return (
      <>
        <Row>
          <Col sm={12} className="d-flex align-items-center">
            <ButtonGroup>
              <Button
                color="link"
                className="pl-0"
                onClick={
                  () =>
                    this.toggleAllLineSelection(configurableRuntimeLines, true)
                  // eslint-disable-object-curly-newline
                }
              >
                Select all
              </Button>
              <Button
                color="link"
                onClick={
                  () =>
                    this.toggleAllLineSelection(configurableRuntimeLines, false)
                  // eslint-disable-object-curly-newline
                }
              >
                Deselect all
              </Button>
            </ButtonGroup>
            <Label className="mr-3 my-auto ml-auto">New end date</Label>
            <DatePicker
              isDayBlocked={day => isInclusivelyBeforeDay(day, previousDay)}
              name="proposedEndDate"
              onChange={onChange}
              value={value.proposedEndDate}
            />
          </Col>
        </Row>
        {linesCombinedByBusinesses.map(businessLine => (
          <React.Fragment key={businessLine.label}>
            <Row>
              <Col sm={12}>
                <h5>{businessLine.label}</h5>
              </Col>
            </Row>
            {businessLine.products.map(product => (
              <Row key={product.label}>
                <Col sm={12}>
                  <h6>
                    <Label for="Select" hidden>
                      Select campaign line
                    </Label>
                    <input
                      type="checkbox"
                      className="ml-4 mr-3"
                      id="selectproduct"
                      name="selectproduct"
                      onClick={
                        event =>
                          this.toggleProductLineSelection(
                            product.id,
                            configurableRuntimeLines,
                            event,
                          )
                        // eslint-disable-object-curly-newline
                      }
                    />
                    {product.label}
                  </h6>
                  <ListGroup className="mb-4">
                    {this.renderCampaignLines(product)}
                  </ListGroup>
                </Col>
              </Row>
            ))}
          </React.Fragment>
        ))}
      </>
    );
  }
}

ChangeRuntimeForm.propTypes = {
  campaignLinesById: objectOf(campaignLineShape.isRequired).isRequired,
  onChange: func.isRequired,
  value: shape({
    proposedEndDate: string.isRequired,
    selectedLines: objectOf(bool).isRequired,
  }).isRequired,
};

export default ChangeRuntimeForm;
